import { isNativePlatform } from './platform';

let Haptics;

const loadHaptics = async () => {
  if (!isNativePlatform()) return null;
  if (!Haptics) {
    const mod = await import('@capacitor/haptics');
    Haptics = mod;
  }
  return Haptics;
};

export const hapticLight = async () => {
  const haptics = await loadHaptics();
  if (!haptics) return;
  try {
    await haptics.Haptics.impact({ style: haptics.ImpactStyle.Light });
  } catch (e) {}
};

export const hapticMedium = async () => {
  const haptics = await loadHaptics();
  if (!haptics) return;
  try {
    await haptics.Haptics.impact({ style: haptics.ImpactStyle.Medium });
  } catch (e) {}
};

export const hapticHeavy = async () => {
  const haptics = await loadHaptics();
  if (!haptics) return;
  try {
    await haptics.Haptics.impact({ style: haptics.ImpactStyle.Heavy });
  } catch (e) {}
};

export const hapticSuccess = async () => {
  const haptics = await loadHaptics();
  if (!haptics) return;
  try {
    await haptics.Haptics.notification({ type: haptics.NotificationType.Success });
  } catch (e) {}
};

export const hapticError = async () => {
  const haptics = await loadHaptics();
  if (!haptics) return;
  try {
    await haptics.Haptics.notification({ type: haptics.NotificationType.Error });
  } catch (e) {}
};

export const hapticVibrate = async (duration = 50) => {
  const haptics = await loadHaptics();
  if (!haptics) return;
  try {
    await haptics.Haptics.vibrate({ duration });
  } catch (e) {}
};
